import NotificationsListComponent from './notifications-list.component'

const NotificationsListModule = angular.module('cdbl.notifications-list', [

])
  .component('cdblNotificationsList', NotificationsListComponent)
  .name

export default NotificationsListModule
